import React from 'react';
import SubjectPage from '../structure/SubjectPage';

const ETW = ({ branch = "AIML", semester = "4th Semester" }) => {
  const accordionContent = [
    <div key="1" className="p-4">
      <p>Introduction to Technical Writing: Basics and guidelines of technical writing, Layout of
        research/review paper, Finalization of Problem Statement, Collection of Primary and
        Secondary data. Processing and analysing the data. Relevance of Literature Review,
        Objectives of Literature Review, Sources of Literature, References, How to Conduct the
        Review of Literature, Precautions in Library Use, Reporting the Review of Literature. Title
        finalization, Abstract formulation, keywords. Citations format: APA, Harvard, Chicago,
        Vancouver. Proper way of writing and citing equations, Proper use of figures and tables,
        Writing a good review paper.</p>
    </div>,
    <div key="2" className="p-4">
      <p>Introduction to Latex: Installation of Latex software, Basics of overleaf, basic syntax,
        writing equations, tables, inserting figures. Page layout- Title, Abstract, Chapters, Sections,
        References, Equation references, Citations. Preparation of table and contents, Figure
        handling numbering, generating index, Creating ordered and unordered list. Packages:
        Geometry, maths, algorithms.
        Introduction to various International template styles- IEEE, Springer, ACM, etc. IndexingClarivate, Scopus, Web of Science, etc.</p>
    </div>,
    <div key="3" className="p-4">
      <p>Ethics and Plagiarism: Seeking consent, ethical committees (human & animal), Ethical
        issues to consider relating to the researcher, IPR- intellectual property rights and patent law,
        commercialization, scholarly publishing, citation and acknowledgement, plagiarism,
        reproducibility and accountability. Concluding the Research Paper: Writing results section, explaining the figures and
        tables, summarizing the result and conclusion, references. Choosing a journal.</p>
    </div>,
    <div key="4" className="p-4">
      <p>Presenting Manuscript: Presentation of Research paper.</p>
    </div>
  ];

  const tabData = [
    { id: 'syllabus', label: 'Syllabus', content: null },
    { id: 'notes', label: 'Notes', content: null },
    { id: 'important', label: 'Important Questions', content: null },
    { id: 'books', label: 'Books', content: null },
    { id: 'PYQ', label: 'PYQ', content: null },
    { id: 'youtube_playlist', label: 'Video Lectures', content: null },
  ];

  return (
    <SubjectPage
      subjectName="Effective Technical Writing"
      subjectKey="AI_ETW"
      branch={branch}
      semester={semester}
      accordionContent={accordionContent}
      tabData={tabData}
      adminEmail="snaped4338@gmail.com"
      firestoreCollections={{
        notes: 'ETWNotes',
        videos: 'ETWVideos'
      }}
    />
  );
};

export default ETW;